export const environment = {
  apiBaseUrl: 'https://str.devtest.gf.aws.scania.com/api',
  url: 'str.devtest.gf.aws.scania.com',
  production: true,
  msalConfig: {
    auth: {
      clientId: '31fbd668-e82b-429a-9be7-6807f3b79ce3',
      authority: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac'
    },
  },
  webApi: {
    uri: 'https://str.devtest.gf.aws.scania.com/api',
    scopes: ['api://43215212-6b98-4548-8cb3-e0ac4b2665b5/str-api.getpostdelete.any'],
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  entraGroup: '588e4123-d33b-4e32-a760-61d6c921c803'
};
